import { createFileRoute } from '@tanstack/react-router'
import { ToolsManager } from '../../../../components/ToolsManager'

export const Route = createFileRoute('/platform/desa/$desaId/tools')({
  component: () => {
    const { desaId } = Route.useParams()
    return <ToolsManager desaId={desaId} />
  },
})
